module.exports = __webpack_public_path__ + "static/media/manovr-4.57765af9.jpg";